import { Fields } from '@app/sharedModule/components/rules-dynamic-form/model';
import { RuleEntity, RuleOperator } from '@pdqdev/pdq-shared/dist/entities/Rules';
import {
  CART_VALUE_RULE,
  COUPON_RULE,
  CUSTOMER_ORDER_COUNT_RULE,
  CUSTOMER_SPEND_RULE,
  DELIVERY_AREA_COUNTRIES_RULE,
  DELIVERY_AREA_DESTINATIONS_RULE,
  DELIVERY_AREA_STATES_RULE,
  DELIVERY_AREA_ZIP_CODES_RULE,
  GROSS_MARGIN_RULE,
  ITEM_COUNT_RULE,
  LOCALE_RULE,
  PAYMENT_GATEWAY_RULE,
  PRODUCT_TAG_RULE,
  PRODUCT_TYPE_RULE,
  PROPERTIES_KEY_RULE,
  PROPERTIES_VALUE_RULE,
  SKU_RULE,
  TIME_OF_DAY_SEGMENTATION_RULE,
  WEEKDAY_SEGMENTATION_RULE,
} from '@app/pages/checkout-app/checkout-layout/main/components/extensions/shared/common-rule-configs';
import {
  BOOLEAN_OPERATORS,
  COLLECTION_OPERATORS,
} from '@app/pages/checkout-app/checkout-layout/main/components/extensions/shared/operators-config';

export const RestrictionRules = [
  DELIVERY_AREA_COUNTRIES_RULE,
  DELIVERY_AREA_ZIP_CODES_RULE,
  DELIVERY_AREA_STATES_RULE,
  {
    entity: RuleEntity.CUSTOMER_TAGS,
    entityOperator: {
      fieldType: Fields.DROP_DOWN,
      defaultValue: { label: RuleOperator.IS, value: RuleOperator.IS },
      operators: BOOLEAN_OPERATORS,
    },
    entityParams: [
      {
        required: true,
        name: 'customerTagsValue',
        defaultValue: '',
        fieldType: Fields.INPUT,
        placeholder: 'Example: tag1, tag2, tag3',
      },
    ],
  },
  CUSTOMER_ORDER_COUNT_RULE,
  PRODUCT_TYPE_RULE,
  PRODUCT_TAG_RULE,
  SKU_RULE,
  WEEKDAY_SEGMENTATION_RULE,
  CART_VALUE_RULE,
  GROSS_MARGIN_RULE,
  CUSTOMER_SPEND_RULE,
  ITEM_COUNT_RULE,
  {
    entity: RuleEntity.SELLING_PLAN,
    entityOperator: {
      fieldType: Fields.DROP_DOWN,
      defaultValue: { label: RuleOperator.IS_ANY, value: RuleOperator.IS_ANY },
      operators: [
        ...COLLECTION_OPERATORS,
        {
          label: RuleOperator.IS,
          value: RuleOperator.IS,
        },
      ],
    },
    entityParams: [
      {
        required: true,
        name: 'sellingPlanValue',
        defaultValue: '',
        fieldType: Fields.INPUT,
        placeholder: 'Selling plan ID',
        hideWhen: (values, operator) => {
          return operator === RuleOperator.IS;
        },
      },
      {
        required: true,
        name: 'sellingPlanExistence',
        defaultValue: 'exist',
        fieldType: Fields.DROP_DOWN,
        options: [
          { label: 'Exist', value: 'exist' },
          { label: 'Not Exist', value: 'not_exist' },
        ],
        hideWhen: (values, operator) => operator !== RuleOperator.IS,
      },
    ],
  },
  PROPERTIES_KEY_RULE,
  PROPERTIES_VALUE_RULE,
  DELIVERY_AREA_DESTINATIONS_RULE,
  LOCALE_RULE,
  COUPON_RULE,
  TIME_OF_DAY_SEGMENTATION_RULE,
  PAYMENT_GATEWAY_RULE,
];
